<template>
  <div class="statistics-pg">
    <Search/>
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="position">
        <div class="bg-white p-20">
          <h1 class="title-pg">{{ $t('Таблица для мониторинга Единого портала') }}</h1>
          <v-row class="mb-4">
            <v-col cols="12" md="4">
              <label>{{ $t('Год') }}</label>
              <v-select
                v-model="filters.year"
                :items="years"
                :aria-label="$t('Год')"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12" md="4">
              <label aria-hidden="true">&nbsp;</label>
              <div class="d-flex align-center">
                <button class="btn btn-default blue mr-2" @click="applyFilters">
                  {{ $t('Применить') }}
                </button>
                <button
                  class="btn btn-default green white--text mr-2"
                  @click="exportToExcel"
                  :disabled="isLoadingExcel"
                >
                  <v-icon left x-small>mdi-file-excel</v-icon>
                  {{ $t('Excel') }}
                </button>
                <button class="btn btn-default" @click="resetFilters">
                  {{ $t('Сбросить') }}
                </button>
              </div>
            </v-col>
          </v-row>
          <div v-if="id == 1" class="statistics-item">
            <h4>{{ $t('Учтённые комментарии') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>{{ $t('ID проекта') }}</td>
                  <td>{{ $t('Наименование проекта') }}</td>
                  <td>{{ $t('Содержание комментария') }}</td>
                  <td>{{ $t('Разработчик') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">{{ index + 1 }}</td>
                  <td class="text-center">
                    <router-link
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_id }}
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :title="item.n_name"
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_name }}
                    </router-link>
                  </td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.visible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.visible && item.c_text.length > maxLength" class="project-goal-gradient"></div>
                    </div>
                    <template v-if="item.c_text.length > maxLength">
                      <br/>
                      <a
                        class="btn-collapse"
                        :aria-expanded="item.visible ? 'true' : 'false'"
                        :aria-controls="String(item.c_id)"
                        @click="item.visible = !item.visible"
                        :href="'#' + item.c_id"
                      >{{ item.visible ? $t("Свернуть") : $t("Показать") }}</a>
                    </template>
                  </td>
                  <td class="text-center">
                    {{ item.d_name }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="id == 2" class="statistics-item">
            <h4>{{ $t('Не отвеченные комментарии') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>{{ $t('ID проекта НПА') }}</td>
                  <td>{{ $t('Наименование проекта НПА') }}</td>
                  <td>{{ $t('Государственный орган-разработчик') }}</td>
                  <td>{{ $t('Публичное имя автора комментария') }}</td>
                  <td>{{ $t('Дата публикации') }}</td>
                  <td>{{ $t('Содержание комментария') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">{{ index + 1 }}</td>
                  <td class="text-center">
                    <router-link
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_id }}
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :title="item.n_name"
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_name }}
                    </router-link>
                  </td>
                  <td>{{ item.d_name }}</td>
                  <td>{{ item.a_name }}</td>
                  <td>{{ new Date(item.c_date) | dateFormat('DD.MM.YYYY') }}</td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.visible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.visible && item.c_text.length > maxLength" class="project-goal-gradient"></div>
                    </div>
                    <template v-if="item.c_text.length > maxLength">
                      <br/>
                      <a
                        class="btn-collapse"
                        :aria-expanded="item.visible ? 'true' : 'false'"
                        :aria-controls="String(item.c_id)"
                        @click="item.visible = !item.visible"
                        :href="'#' + item.c_id"
                      >{{ item.visible ? $t("Свернуть") : $t("Показать") }}</a>
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="id == 3" class="statistics-item">
            <h4>{{ $t('Ответы , которые даны с нарушением срока') }}</h4>
            <div class="table-overflow">
              <table>
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>{{ $t('ID проекта НПА') }}</td>
                  <td>{{ $t('Наименование проекта НПА') }}</td>
                  <td>{{ $t('Государственный орган-разработчик') }}</td>
                  <td>{{ $t('Публичное имя автора комментария') }}</td>
                  <td>{{ $t('Дата публикации') }}</td>
                  <td>{{ $t('Содержание комментария') }}</td>
                  <td>{{ $t('Количество просроченных дней') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in statistics" :key="item.c_id">
                  <td class="td-num">
                    {{ index + 1 }}
                  </td>
                  <td class="text-center">
                    <router-link
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_id }}
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :title="item.n_name"
                      :to="$i18nRoute({
                        name: 'view-npa',
                        params: { id: item.n_id },
                        query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                      })"
                    >
                      {{ item.n_name }}
                    </router-link>
                  </td>
                  <td>{{ item.d_name }}</td>
                  <td>{{ item.a_name }}</td>
                  <td class="text-center">
                    {{ new Date(item.c_date) | dateFormat('DD.MM.YYYY') }}
                  </td>
                  <td>
                    <div :id="item.c_id" class="text-collapse-wrap">
                      <div
                        class="text-collapse"
                        :class="{ height_inherit: item.commentVisible === true || item.c_text.length <= maxLength }"
                      >
                        <router-link
                          :title="item.c_text | strippedContent"
                          :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: item.n_id },
                          query: { comment: item.c_id, ver:item.v_id, block: item.b_id ? item.b_lang+'_'+item.b_id : null }
                        })"
                          :key="item.id"
                        >
                          <div v-html="item.c_text"></div>
                        </router-link>
                      </div>
                      <div v-if="!item.commentVisible || item.c_text.length > maxLength"
                           class="project-goal-gradient"></div>
                    </div>
                    <br/>
                    <a
                      class="btn-collapse"
                      :aria-expanded="item.commentVisible ? 'true' : 'false'"
                      :aria-controls="String(item.c_id)"
                      @click="item.commentVisible = !item.commentVisible"
                      :href="'#' + item.c_id"
                    >{{ item.commentVisible ? $t("Свернуть") : $t("Показать") }}</a>
                  </td>
                  <td class="text-center">
                    {{ item.date_diff }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Search from '@/components/Search'
import NPA from '@/model/npa'
import { mapGetters, mapMutations } from 'vuex'
import {Trans} from "@/plugins/Translation"
import mixin from '@/plugins/mixin/mixin'
import i18n from '@/plugins/i18n'

export default {
  mixins: [mixin],
  components: {
    Search
  },
  data: () => ({
    id: null,
    breadcrumbs: [],
    statistics: [],
    years: [],
    filters: {
      year: null
    },
    maxLength: 280,
    search: {},
    orderBy: 'date',
    orderDir: 'desc',
    refCategory: [],
    refDeveloper: [],
    page: 1,
    isLoadingExcel: false,
  }),
  metaInfo() {
    return {
      title: this.$i18n.t('CommentStatisticsTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('CommentStatisticsDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('CommentStatisticsKeywordsSEO'),
      }]
    }
  },
  async mounted() {
    await this.fetchData()
    this.scrollToTop()
  },
  computed: {
    ...mapGetters({
      searchData: 'getSearchData'
    }),
  },
  methods: {
    ...mapMutations(['setLoading']),
    async fetchData() {
      this.setLoading(true)
      try {
        this.id = this.$route.params.id
        this.breadcrumbs = [
          {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
          {text: this.$i18n.t('Таблица для мониторинга Единого портала'), disabled: true}
        ]
        if (this.id == 2) {
          this.refCategory = this.searchData.refCategory
          this.refDeveloper = this.searchData.refDeveloper
        }
        await this.loadYears()
        this.initFiltersFromRoute()
        await this.commentStatistics()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.setLoading(false)
      }
    },
    initFiltersFromRoute() {
      const routeYear = this.$route.query.year
      this.filters.year = routeYear ? Number(routeYear) : null
    },
    async loadYears() {
      const response = await this.$http.get(`${i18n.locale}/api/statistics/available-years`)
      const years = Array.isArray(response.data.years) ? response.data.years.map((year) => Number(year)) : []
      const routeYear = this.$route.query.year ? Number(this.$route.query.year) : null

      if (routeYear && !years.includes(routeYear)) {
        years.push(routeYear)
      }

      this.years = years.sort((left, right) => right - left)
    },
    getRequestParams() {
      const params = {
        ...this.search,
        orderBy: this.orderBy,
        orderDir: this.orderDir
      }

      if (this.filters.year) {
        params.year = this.filters.year
      }

      return params
    },
    async commentStatistics() {
      this.setLoading(true)
      try {
        const response = await NPA.getCommentStatistics(this.$route.params.id, this.getRequestParams())
        this.statistics = response.data
      } catch (error) {
        this.handleError(error)
      } finally {
        this.setLoading(false)
      }
    },
    sortData(sort) {
      this.orderBy = sort.key
      this.orderDir = sort.value
      this.commentStatistics()
    },
    sortingFilterHandler(filter) {
      this.search[filter.name] = filter.value
      this.commentStatistics()
    },
    applyFilters() {
      this.updateRouteQuery()
      this.commentStatistics()
    },
    resetFilters() {
      this.filters.year = null
      this.updateRouteQuery()
      this.commentStatistics()
    },
    exportToExcel() {
      if (this.isLoadingExcel) {
        return
      }

      this.isLoadingExcel = true
      NPA.exportCommentStatisticsExcel(this.$route.params.id, this.getRequestParams())
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url

          const date = new Date().toISOString().slice(0, 10)
          link.setAttribute('download', `comment_statistics_${this.$route.params.id}_${date}.xlsx`)
          link.style.display = 'none'

          document.body.appendChild(link)
          link.click()

          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)

          this.$noty.success(this.$t('Файл успешно сформирован'), {
            killer: true, timeout: 2000, layout: 'topRight'
          })
        })
        .catch(() => {
          this.$noty.error(this.$t('Ошибка при экспорте файла'), {
            killer: true, timeout: 2000, layout: 'topRight'
          })
        })
        .finally(() => {
          this.isLoadingExcel = false
        })
    },
    updateRouteQuery() {
      const query = {}

      if (this.filters.year) {
        query.year = String(this.filters.year)
      }

      this.$router.replace(this.$i18nRoute({
        name: 'comment-statistics',
        params: { id: this.id },
        query
      })).catch(() => {})
    },
    handleError(error) {
      this.$router.push(Trans.i18nRoute({
        name: 'error',
        params: {
          status: error.response.status
        }
      }))
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    cancelSorting () {
      this.orderBy = 'date'
      this.orderDir = 'desc'
      this.commentStatistics()
    }
  }
}
</script>
